// components/delivery/deliveryTrackingComponents/PauseDialog/PauseDialog.jsx
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import styles from "./PauseDialog.module.scss";

const PauseDialog = ({ visible, onHide, onConfirmPause, isPaused }) => {
    const [pauseReason, setPauseReason] = useState("");
    const [estimatedDuration, setEstimatedDuration] = useState(null);
    const [customReason, setCustomReason] = useState("");

    const reasonOptions = [
        { label: "Break", value: "Break" },
        { label: "Fuel Stop", value: "Fuel Stop" },
        { label: "Vehicle Issue", value: "Vehicle Issue" },
        { label: "Traffic Delay", value: "Traffic Delay" },
        { label: "Weather Conditions", value: "Weather Conditions" },
        { label: "Meal Break", value: "Meal Break" },
        { label: "Emergency", value: "Emergency" },
        { label: "Other", value: "Other" },
    ];

    const durationOptions = [
        { label: "5 minutes", value: 5 },
        { label: "10 minutes", value: 10 },
        { label: "15 minutes", value: 15 },
        { label: "30 minutes", value: 30 },
        { label: "1 hour", value: 60 },
        { label: "More than 1 hour", value: 120 },
    ];

    const handleConfirm = () => {
        const finalReason = pauseReason === "Other" ? customReason : pauseReason;

        if (!finalReason.trim()) {
            return;
        }

        onConfirmPause({
            reason: finalReason,
            estimatedDuration: estimatedDuration || 0,
        });

        // Reset form
        setPauseReason("");
        setEstimatedDuration(null);
        setCustomReason("");
        onHide();
    };

    const handleResume = () => {
        onConfirmPause({ resume: true });
        onHide();
    };

    return (
        <Dialog visible={visible} onHide={onHide} header={isPaused ? "Resume Delivery" : "Pause Delivery"} className={styles.pauseDialog} draggable={false} blockScroll>
            <div className={styles.dialogContent}>
                {!isPaused ? (
                    <>
                        <p className={styles.dialogDescription}>
                            <i className="pi pi-info-circle" />
                            Please provide a reason for pausing the delivery. This will be recorded in the timeline.
                        </p>

                        <div className={styles.formGroup}>
                            <label>Reason for Pause *</label>
                            <Dropdown value={pauseReason} options={reasonOptions} onChange={(e) => setPauseReason(e.value)} placeholder="Select a reason" className={styles.dropdown} />
                        </div>

                        {pauseReason === "Other" && (
                            <div className={styles.formGroup}>
                                <label>Custom Reason *</label>
                                <InputTextarea value={customReason} onChange={(e) => setCustomReason(e.target.value)} placeholder="Enter reason for pause..." rows={3} className={styles.textarea} autoFocus />
                            </div>
                        )}

                        <div className={styles.formGroup}>
                            <label>Estimated Duration</label>
                            <Dropdown value={estimatedDuration} options={durationOptions} onChange={(e) => setEstimatedDuration(e.value)} placeholder="Select estimated duration" className={styles.dropdown} />
                        </div>

                        <div className={styles.dialogActions}>
                            <Button label="Cancel" icon="pi pi-times" onClick={onHide} outlined className={styles.cancelButton} />
                            <Button label="Pause Delivery" icon="pi pi-pause" onClick={handleConfirm} disabled={!pauseReason || (pauseReason === "Other" && !customReason.trim())} severity="warning" className={styles.confirmButton} />
                        </div>
                    </>
                ) : (
                    <>
                        <p className={styles.dialogDescription}>
                            <i className="pi pi-info-circle" />
                            Ready to resume delivery?
                        </p>

                        <div className={styles.resumeInfo}>
                            <i className="pi pi-clock" />
                            <span>The delivery will continue from where you left off.</span>
                        </div>

                        <div className={styles.dialogActions}>
                            <Button label="Cancel" icon="pi pi-times" onClick={onHide} outlined className={styles.cancelButton} />
                            <Button label="Resume Delivery" icon="pi pi-play" onClick={handleResume} severity="success" className={styles.confirmButton} />
                        </div>
                    </>
                )}
            </div>
        </Dialog>
    );
};

export default PauseDialog;
